import React, { useEffect, useState } from 'react';
import { Button } from '../components/ui/button';

const TECHNIQUES = [
    { key: '4-7-8', label: '4-7-8', inhale: 4, hold: 7, exhale: 8, desc: 'Demper stress og hjelper deg å sovne' },
    { key: 'boks', label: 'Boks-pust', inhale: 4, hold: 4, exhale: 4, hold2: 4, desc: 'Skaper rolig fokus' },
    { key: 'rolig', label: 'Rolig pust', inhale: 5, hold: 2, exhale: 6, desc: 'Balanserer nervesystemet' },
];

const BG = "https://images.pexels.com/photos/7135013/pexels-photo-7135013.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function Breathing() {
    const [tech, setTech] = useState(TECHNIQUES[0]);
    const [running, setRunning] = useState(false);
    const [phase, setPhase] = useState('Klar');
    const [count, setCount] = useState(0);
    const [cycles, setCycles] = useState(0);

    useEffect(() => {
        if (!running) return;
        let cancelled = false;

        const runCycle = async () => {
            const steps = [
                { name: 'Pust inn', sec: tech.inhale },
                { name: 'Hold', sec: tech.hold },
                { name: 'Pust ut', sec: tech.exhale },
            ];
            if (tech.hold2) steps.push({ name: 'Hold', sec: tech.hold2 });
            for (const step of steps) {
                if (cancelled) return;
                setPhase(step.name);
                for (let s = step.sec; s > 0; s--) {
                    if (cancelled) return;
                    setCount(s);
                    await new Promise(r => setTimeout(r, 1000));
                }
            }
            if (!cancelled) {
                setCycles(c => c + 1);
                runCycle();
            }
        };
        runCycle();
        return () => { cancelled = true; };
    }, [running, tech]);

    const scale = phase === 'Pust inn' ? 'scale-150' : phase === 'Pust ut' ? 'scale-90' : 'scale-125';

    return (
        <div className="relative min-h-[calc(100vh-56px)] md:min-h-screen overflow-hidden" data-testid="breathing-page">
            <div className="absolute inset-0">
                <img src={BG} alt="" className="w-full h-full object-cover opacity-60"/>
                <div className="absolute inset-0 bg-gradient-to-b from-bone/80 via-bone/50 to-bone/90"/>
            </div>
            <div className="relative max-w-3xl mx-auto px-6 py-10 pb-24">
                <h1 className="font-display text-3xl font-bold tracking-tight">Pustepauser</h1>
                <p className="mt-2 text-inkSoft">Velg en teknikk. Følg sirkelen.</p>

                <div className="mt-6 flex flex-wrap gap-2" data-testid="technique-buttons">
                    {TECHNIQUES.map(t => (
                        <button key={t.key} onClick={() => { setTech(t); setRunning(false); setCycles(0); setPhase('Klar'); }}
                            className={`px-4 py-2 rounded-full text-sm transition-colors ${tech.key === t.key ? 'bg-sage text-bone' : 'bg-white border border-sand text-ink hover:border-sage/40'}`}
                            data-testid={`tech-${t.key}`}>{t.label}</button>
                    ))}
                </div>
                <p className="text-sm text-inkSoft mt-2">{tech.desc}</p>

                <div className="mt-12 flex flex-col items-center">
                    <div className={`w-56 h-56 sm:w-72 sm:h-72 rounded-full bg-sage/20 flex items-center justify-center transition-transform duration-[4000ms] ease-in-out ${scale}`} data-testid="breathing-circle">
                        <div className="w-40 h-40 sm:w-48 sm:h-48 rounded-full bg-sage/40 flex items-center justify-center">
                            <div className="text-center">
                                <p className="font-display text-2xl font-semibold text-ink">{phase}</p>
                                {running && count > 0 && <p className="text-inkSoft text-sm mt-1">{count}</p>}
                            </div>
                        </div>
                    </div>

                    <Button
                        onClick={() => { setRunning(r => !r); if (running) setPhase('Klar'); }}
                        className="mt-10 rounded-full bg-sage hover:bg-sage-dark text-bone px-10 h-12"
                        data-testid="breathing-toggle">
                        {running ? 'Pause' : 'Start'}
                    </Button>

                    {cycles > 0 && <p className="text-sm text-inkSoft mt-4">Sykluser fullført: {cycles}</p>}
                </div>
            </div>
        </div>
    );
}
